<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        scrollable
        v-on:close="toggledialog({})"
        v-on:click:outside="toggledialog({})"
    >
      <v-card>
        <v-card-title>Detail Bill</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Date
                </th>
                <th class="text-left">
                  ID Reseller
                </th>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  Amount
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in detailBills"
                  :key="item.id"
              >
                <td>{{ item.date }}</td>
                <td>{{ item.idreseller }}</td>
                <td>{{ item.resellername }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
              color="blue darken-1"
              text
              @click="toggledialog({})"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from "moment";
import {mapActions, mapState} from "vuex";
import Utils from "@/plugins/utils";

export default {
  name: "ModalBills",
  data: ()=>({

  }),
  mounted() {
    console.log('OPEN MY MODAL')
  },
  computed: {
    ...mapState('Bayartempo',['dialog', 'detailBills'])
  },
  methods: {

    ...mapActions('Bayartempo',['toggledialog']),
    formatAngka(val){
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
    },

  }
}
</script>